import "sass/plato.scss";
import { initPlatoVideos } from "plato-videos";

// ----------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
  initPlatoVideos("plato-video");
});
